const cssStyles = () => {
  let styles = '';
  const placeholderSelectors = [
    'placeholder',
    '-webkit-input-placeholder', // Chrome / Opera / Safari
    '-moz-placeholder', // Firefox
    '-ms-input-placeholder', // IE
    '-moz-placeholder', // older Firefox
  ];
  for (const selectorIndex in placeholderSelectors) {
    styles += `
.UnauthTextInputField__gray::${placeholderSelectors[selectorIndex]} {
  color: #8e8e8e;
}
.UnauthTextInputField__darkGray::${placeholderSelectors[selectorIndex]} {
  color: #333;
}
`;
  }

  return styles;
};

export default cssStyles;
